import * as React from "react";

import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import Box from "@mui/material/Box";
import List from "@mui/material/List";
import { Theme } from "@mui/material/styles";

import { useTranslation } from "react-i18next";

import { Styles } from "../../styles";
import {
  DrawerMenu,
  DrawerMenuItem,
  SystemTablesSubItem,
} from "../DrawerMenu";

type DrawerContentProps = {
  styles: ReturnType<typeof Styles>;
  theme: Theme;
  isSystemManagementOpen: boolean;
  menuItems: DrawerMenuItem[];
  systemTablesSubItems: SystemTablesSubItem[];
  isSystemTablesExpanded: boolean;
  setIsSystemTablesExpanded: React.Dispatch<React.SetStateAction<boolean>>;
  urlParam: string;
  isItemActive: (route: string) => boolean;
  isSubItemActive: (route: string) => boolean;
  openSystemManagement: () => void;
  closeSystemManagement: () => void;
  setIsSystemManagementClosedManually: React.Dispatch<React.SetStateAction<boolean>>;
  changeLanguage: (language: "hw" | "en") => void;
  currentLanguage: string;
};

export const DrawerContent = ({
  styles,
  theme,
  isSystemManagementOpen,
  menuItems,
  systemTablesSubItems,
  isSystemTablesExpanded,
  setIsSystemTablesExpanded,
  urlParam,
  isItemActive,
  isSubItemActive,
  openSystemManagement,
  closeSystemManagement,
  setIsSystemManagementClosedManually,
  changeLanguage,
  currentLanguage,
}: DrawerContentProps) => {
  const { t } = useTranslation();

  return (
    <Box className={styles.drawerRoot}>
      <Box
        className={`${styles.logoImage} ${
          isSystemManagementOpen ? styles.logoImageWithoutBorder : ""
        }`}
      >
        <span className={styles.logoText}>Silagi</span>
      </Box>

      {isSystemManagementOpen && (
        <button
          type="button"
          className={styles.backButton}
          onClick={closeSystemManagement}
        >
          <ArrowForwardIcon className={styles.backButtonIcon} />
          {t("SIDEBAR.BACK_TO_SILAGI")}
        </button>
      )}

      <List className={styles.drawerList}>
        <DrawerMenu
          styles={styles}
          theme={theme}
          menuItems={menuItems}
          systemTablesSubItems={systemTablesSubItems}
          isSystemManagementOpen={isSystemManagementOpen}
          isSystemTablesExpanded={isSystemTablesExpanded}
          setIsSystemTablesExpanded={setIsSystemTablesExpanded}
          urlParam={urlParam}
          isItemActive={isItemActive}
          isSubItemActive={isSubItemActive}
          openSystemManagement={openSystemManagement}
          setIsSystemManagementClosedManually={setIsSystemManagementClosedManually}
        />
      </List>

      <Box className={styles.languageWrapper}>
        <button
          type="button"
          onClick={() => changeLanguage("hw")}
          className={
            currentLanguage === "hw"
              ? styles.activeLanguageButton
              : styles.languageButton
          }
        >
          {t("SIDEBAR.HEBREW")}
        </button>

        <button
          type="button"
          onClick={() => changeLanguage("en")}
          className={
            currentLanguage === "en"
              ? styles.activeLanguageButton
              : styles.languageButton
          }
        >
          {t("SIDEBAR.ENGLISH")}
        </button>
      </Box>
    </Box>
  );
};
